import useGetExperimentVariant from './useGetExperimentVariant'

const useGetExperimentActive = (key: string) => {
  const { isReady, value: variantValue } = useGetExperimentVariant(key)

  return {
    loading: !isReady,
    active: variantValue === 'test',
  }
}

export default useGetExperimentActive
